import { ArrowDownIcon, emptyFragment, IconButton } from '@execonline-inc/execonline-ui';
import { when } from '@execonline-inc/maybe-adapter';
import { fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import { MutableRefObject } from 'react';
import { isScrolledToBottom, scrollElementToBottom } from './utils';
import { useAutoScroll } from './AutoScrollContext';

interface Props {
  messagesEndRef: MutableRefObject<HTMLDivElement | null>;
}

const scrollDisabledAndNotAtBottom = (isAutoScrollEnabled: boolean) => (element: HTMLDivElement) =>
  when(!isAutoScrollEnabled && !isScrolledToBottom(element), element);

function ScrollToBottomButton({ messagesEndRef }: Props) {
  const { isAutoScrollEnabled, setIsAutoScrollEnabled } = useAutoScroll();

  return fromNullable(messagesEndRef.current)
    .andThen(scrollDisabledAndNotAtBottom(isAutoScrollEnabled))
    .map((element) => (
      <IconButton
        className="absolute bottom-20 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-white border border-gray-300 rounded-full cursor-pointer"
        onClick={() => {
          setIsAutoScrollEnabled(true);
          scrollElementToBottom(element);
        }}
      >
        <ArrowDownIcon size="md" className="items-center" />
      </IconButton>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ScrollToBottomButton);
